<template>
  <div class="ShadowBevel" :is="as" :style="computedStyles">
    <slot />
  </div>
</template>

<script>
import { getResponsiveValue, mapResponsiveProp } from '@/components/polaris/polarisUtils';

export default {
  name: 'PShadowBevel',
  props: {
    as: {
      type: String,
      default: 'div',
    },
    boxShadow: {
      type: String,
      required: true,
    },
    borderRadius: {
      type: String,
      required: true,
    },
    zIndex: {
      type: String,
      default: null,
    },
    bevel: {
      type: [Boolean, Object],
      default: true,
    },
  },
  computed: {
    computedStyles: function () {
      return {
        '--pc-shadow-bevel-z-index': this.zIndex,
        ...getResponsiveValue(
          'shadow-bevel',
          'content',
          mapResponsiveProp(this.bevel, bevel => (bevel ? '""' : 'none'))
        ),
        ...getResponsiveValue(
          'shadow-bevel',
          'box-shadow',
          mapResponsiveProp(this.bevel, bevel =>
            bevel ? `var(--p-shadow-${this.boxShadow})` : 'none'
          )
        ),
        ...getResponsiveValue(
          'shadow-bevel',
          'border-radius',
          mapResponsiveProp(this.bevel, bevel =>
            bevel ? `var(--p-border-radius-${this.borderRadius})` : 'var(--p-border-radius-0)'
          )
        ),
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/polaris/_common.scss';

.ShadowBevel {
  overflow: clip;
  // stylelint-disable-next-line -- Explicitly set `0` to create a local stacking context. While the initial `z-index: auto` has a stack level of `0` within the current stacking context, it does not create a new local stacking context.

  @include scope-custom-property('shadow-bevel', 'z-index');

  @include responsive-props(
    $componentName: 'shadow-bevel',
    $componentProp: 'box-shadow',
    $declarationProp: '--pc-shadow-bevel-box-shadow'
  );
  @include responsive-props(
    $componentName: 'shadow-bevel',
    $componentProp: 'border-radius',
    $declarationProp: '--pc-shadow-bevel-border-radius'
  );
  @include responsive-props(
    $componentName: 'shadow-bevel',
    $componentProp: 'content',
    $declarationProp: '--pc-shadow-bevel-content'
  );

  @include shadow-bevel(
    $boxShadow: var(--pc-shadow-bevel-box-shadow),
    $borderRadius: var(--pc-shadow-bevel-border-radius),
    $content: var(--pc-shadow-bevel-content),
    $zIndex: var(--pc-shadow-bevel-z-index)
  );
}
</style>
